import React from 'react'

export default function GuideSidebar({
  modoCaso, edadDetectada, aniosTareasCuidado, aniosAportesTotales,
  estadoJubilatorio, normativeVersion, normativeAudit, faltanMesesAporte,
  mostrarViabilidad, setMostrarViabilidad, formStep,
}) {
  return (
    <aside className="xl:sticky xl:top-4 xl:self-start">
      <div className="rounded-xl border border-white/15 bg-white/5 p-3">
        <p className="text-xs uppercase tracking-wide text-slate-300">Resumen de Situacion</p>
        <p className="mt-2">
          <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${modoCaso.badgeClass}`}>
            {modoCaso.label}
          </span>
        </p>
        <p className="mt-2 text-sm text-slate-100">Edad detectada: <span className="font-semibold text-profile-accent">{edadDetectada} años</span></p>
        <p className="mt-1 text-sm text-slate-100">Aportes por Tareas de Cuidado: <span className="font-semibold text-emerald-200">{aniosTareasCuidado.toFixed(1)} años</span></p>
        <p className="mt-1 text-sm text-slate-100">Aportes totales estimados: <span className="font-semibold text-sky-200">{aniosAportesTotales.toFixed(1)} años</span></p>
        <p className="mt-2 text-sm text-slate-100">Estado: <span className="font-semibold text-profile-warn">{estadoJubilatorio}</span></p>
        <p className="mt-1 text-xs text-slate-300">Version normativa activa: {normativeVersion}</p>
        {normativeAudit.length > 0 && (
          <details className="mt-2 rounded-lg border border-white/15 bg-white/5 p-2">
            <summary className="cursor-pointer text-[11px] text-slate-300">Bitacora normativa (ultimos eventos)</summary>
            <div className="mt-2 space-y-1 text-[11px] text-slate-200">
              {normativeAudit.slice(0, 5).map((ev, i) => (
                <p key={`audit-${i}`}>- {ev.action || 'evento'} | {ev.version || ev.updateId || 'N/D'} | {ev.toStatus || 'N/D'}</p>
              ))}
            </div>
          </details>
        )}
        {faltanMesesAporte > 0 && (
          <div className="panel-profile-warn mt-3 rounded-lg p-2 text-xs text-profile-warn">
            Requiere comprar {faltanMesesAporte} meses mediante Unidad de Pago de Deuda Previsional (Ley 27.705).
          </div>
        )}
        <button type="button" onClick={() => setMostrarViabilidad((v) => !v)} className="btn-profile-accent mt-3 w-full rounded-lg px-3 py-2 text-xs font-semibold">
          Ver Viabilidad Jubilatoria
        </button>
        {mostrarViabilidad && (
          <div className="mt-2 rounded-lg border border-white/20 bg-slate-900/50 p-2 text-xs text-slate-200">
            {faltanMesesAporte <= 0 ? 'Estado VERDE: titular con derecho potencial completo para iniciar beneficio.' : `Estado AMBAR: la parte debera regularizar ${faltanMesesAporte} meses de aportes mediante Ley 27.705 para acceder al beneficio.`}
            <p className="mt-2 text-[11px] text-slate-300">Nota: El reajuste aqui planteado se enfoca en la recomposicion de los haberes derivados de aportes efectivos. Respecto a las Unidades de Pago de Deuda Previsional (Ley 27.705), se mantiene la reserva de ley segun la vigencia del plan de pagos.</p>
          </div>
        )}
      </div>
      <div className="mt-3 rounded-xl border border-cyan-300/30 bg-cyan-500/10 p-3">
        <p className="text-xs uppercase tracking-wide text-cyan-100">Guia de carga y validacion</p>
        <div className="mt-2 space-y-2 text-xs text-cyan-50/90">
          {formStep < 4 && <p>- Completa tarjetas en orden: datos personales, cuidado y estrategia. Sin eso no se habilita la carga laboral.</p>}
          {formStep === 4 && <p>- Si falta un tramo laboral, usa "Agregar periodo manual por rango" (desde/hasta, empleador, CUIT).</p>}
          {formStep === 4 && <p>- Carga siempre monto bruto. En junio/diciembre marca "Incluye SAC" solo si ese bruto lo contiene.</p>}
          {formStep === 4 && <p>- Si "Incluye SAC" esta activo, el sistema descuenta SAC una sola vez para el monto computable.</p>}
          {formStep >= 5 && <p>- Antes de generar informe/dictamen, revisa filas resaltadas y alertas de integridad.</p>}
          <p>- Regla anti-error: no cargues manualmente monto ya descontado por SAC cuando marques "Incluye SAC".</p>
        </div>
      </div>
    </aside>
  )
}
